<template>
  <b-container class="container-fluid" style="margin-top:90px;">
    <br/>
    <b-row>
      <b-col cols="6">
        <h3>Welcome Back, {{name}}!</h3>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
          Lectus vestibulum mattis ullamcorper velit sed ullamcorper morbi. 
          Faucibus purus in massa tempor nec feugiat nisl pretium fusce. 
          Senectus et netus et malesuada fames ac turpis.</p>
        <b-button style="background-color: #660032;"> Resume Assignments</b-button>
        &nbsp;
        <b-button variant="warning" style="color:white;"> My Assignments</b-button>
        
      </b-col>
      <b-col cols="6">
        <b-row>
          <b-col cols="1"></b-col>
          <h2>Featured Content - August 2022</h2>
        </b-row>
        <b-col cols="auto" style="background-color: lightgrey;border-radius: 10px">
          <br/>
        <b-row>
          <browse-entry
              v-for="(entry,index) in this.data"
              v-bind:key="entry.ID"
              v-bind:ID="entry.ID"
              v-bind:Thumbnail="entry.Thumbnail"
              v-bind:FileURL="entry.Location"
              v-bind:ContentType="entry.ContentType"
              v-bind:Title="entry.Title"
              v-bind:ComponentName="entry.Component"
              v-bind:IsAssignment="entry.IsAssignment"
              v-bind:BaseContent="entry.BaseContent"
              v-bind:StartPoint="entry.StartPoint"
              v-bind:EndPoint="entry.EndPoint"
              v-bind:onLanding="true"
              v-bind:index="index"
          />
        </b-row>
        </b-col>
      </b-col>
    </b-row>
    <br/>
    <b-row>
      <b-col style="background-color: lightgrey; border-radius: 10px">
        <br/>
        <div>
          <b-row class="mx-auto">
            <b-col cols="1">
              <font-awesome-icon icon="fa-solid fa-circle-check" style="color: #660032;"/>
            </b-col>
            <b-col cols="auto">
              <h5>Current Assignments</h5>
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>
            </b-col>
            <b-col>
              <p>8/20/2021</p>  
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>  
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>  
            </b-col>
            <b-col>
              <p>8/20/2021</p>  
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <a href="" style="color: #660032">Show More ></a>  
            </b-col>
          </b-row>
          <br/>
        </div>
      </b-col>
      &nbsp;&nbsp;
      <b-col style="background-color: lightgrey; border-radius: 10px">
        <br/>
        <b-row class="mx-auto">
          <b-col cols="1">
            <font-awesome-icon icon="fa-solid fa-circle-check" style="color:#ffcc00;"/>
          </b-col>
          <b-col cols="auto">
            <h5>Assignments Due</h5>
          </b-col>
        </b-row>
        <b-row class="mx-auto">
          <b-col>
            <p> - Lorem ipsum dolor sit amet</p>  
          </b-col>
        </b-row>
        <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>
            </b-col>
            <b-col>
              <p>8/20/2021</p>  
            </b-col>
          </b-row>
        <b-row class="mx-auto">
          <b-col>
            <p> - Lorem ipsum dolor sit amet</p>  
          </b-col>
        </b-row>
        <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>  
            </b-col>
            <b-col>
              <p>8/20/2021</p>  
            </b-col>
          </b-row>
        <b-row class="mx-auto">
            <b-col>
              <a href="" style="color: #660032">Show More ></a>  
            </b-col>
          </b-row>
        <br/>
      </b-col>
      &nbsp;&nbsp;
      <b-col style="background-color: lightgrey; border-radius: 10px">
        <br/>
        <div>
          <b-row class="mx-auto">
            <b-col cols="1">
              <font-awesome-icon icon="fa-solid fa-circle-check" style="color:#ffcc00"/>
            </b-col>
            <b-col cols="auto">
              <h5>New Assignments</h5>
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>  
            </b-col>
            
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>  
            </b-col>
            <b-col>
              <p>8/20/2021</p>  
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <p> - Lorem ipsum dolor sit amet</p>  
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <label><b>Due Date:</b></label>  
            </b-col>
            <b-col>
              <p>8/20/2021</p>  
            </b-col>
          </b-row>
          <b-row class="mx-auto">
            <b-col>
              <a href="" style="color: #660032">Show More ></a>  
            </b-col>
            
          </b-row>
          <br/>
        </div>
      </b-col>
      
      <b-col>
        <br/>
        <br/>
        <b-col md="10" offset-md="2">
          <b-button-group vertical size="md">
            <b-button type="button"  style="background-color: #660032; border-radius: 5px;"> Resume Course</b-button> <br/>
            <b-button type="button" variant="warning" style="color:white; border-radius: 5px;">My Messages</b-button>
          </b-button-group>
        </b-col>
 
      </b-col>
    </b-row>
    
    
  </b-container>
</template>

<script>
import {ajaxGet} from "@/ajax";
import BrowseEntry from "../BrowseEntry";
export default {
  name: "student",
  components: {
    BrowseEntry
  },
  props: ["browsetype", "token"],
  data: function() {
    return{
      isLoading: false,
      data:[],
      name:''
    }
  },
  mounted() {
    let featuredComp = this;
    this.name = localStorage.Name; 
    setTimeout(function() {
      ajaxGet("https://2kh340dg9j.execute-api.us-east-1.amazonaws.com/content/featuredContent",
          featuredComp.dataSuccessLoad,
          featuredComp.dataError,
          localStorage.token
      );
    }, 50);
  },
  methods: {
    dataSuccessLoad: function (res) {
      this.data = res;
      this.loading = false;
    },
    dataError: function (status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }

      this.loading = false;
    },
  }
}
</script>

<style scoped>

</style>